import FileList from "../components/Dashboard/FileList";
import ProtectedRoute from "../components/Layout/ProtectedRoute";
import useWakeUpPing from "../hooks/useWakeUpPing";
import "./Dashboard.scss";

export default function Dashboard() {
  useWakeUpPing(4); // Ping backend every 4 min

  return (
    <ProtectedRoute>
      <div className="dashboard-page">
        <FileList />
      </div>
    </ProtectedRoute>
  );
}
